/**
 * When the customer changes market/country, submit the default locale for that market
 * instead of keeping the previously selected language.
 */
(function () {
  function getLocaleFromSelect(select) {
    const option = select.options[select.selectedIndex];
    return option ? option.getAttribute('data-locale-code') : null;
  }

  function syncLocaleOnCountryChange(form, localeCode) {
    if (!form) return;

    const localeInput = form.querySelector('input[name="locale_code"]');

    if (!localeCode) {
      if (localeInput) localeInput.disabled = true;
      return;
    }

    if (localeInput) {
      localeInput.value = localeCode;
      localeInput.disabled = false;
      return;
    }

    const createdInput = document.createElement('input');
    createdInput.type = 'hidden';
    createdInput.name = 'locale_code';
    createdInput.value = localeCode;
    form.appendChild(createdInput);
  }

  function handleCountryButtonClick(event) {
    const button = event.target.closest('button[name="country_code"][type="submit"]');
    if (!button || !button.form) return;

    syncLocaleOnCountryChange(button.form, button.getAttribute('data-locale-code'));
  }

  function handleCountrySelectChange(event) {
    const select = event.target;
    if (!select.matches('select[name="country_code"]') || !select.form) return;

    syncLocaleOnCountryChange(select.form, getLocaleFromSelect(select));
  }

  document.addEventListener('click', handleCountryButtonClick, true);
  document.addEventListener('change', handleCountrySelectChange, true);
})();
